export enum JoinFormType {
  JoinAR = 'JoinAR',
  JoinRA = 'JoinRA',
  JoinCR = 'JoinCR',
}

export const joinFormTextType = {
  [JoinFormType.JoinAR]: 'initialArOnboarding',
  [JoinFormType.JoinRA]: 'initialRaOnboarding',
  [JoinFormType.JoinCR]: 'additionalCrOnboarding',
} as const;
